import Vue from "vue";
import VueI18n from "vue-i18n";
import zh from "./zh";
import en from "./en";
import ElementLocale from "element-ui/lib/locale";
import enLocale from "element-ui/lib/locale/lang/en";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
ElementLocale.i18n((key, value) => i18n.t(key, value));

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "zh", // 语言标识
  fallbackLocale: "zh",
  messages: {
    zh: {
      ...zh,
      ...zhLocale,
    },
    en: {
      ...en,
      ...enLocale,
    },
  },
});

export default i18n;
